import { render, staticRenderFns } from "./DocumentosForm.vue?vue&type=template&id=9ab34f22"
import script from "./DocumentosForm.vue?vue&type=script&lang=ts"
export * from "./DocumentosForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports